const SKIP = /^(\.|thumbs\.db$|desktop\.ini$)/i;

function readAll(reader) {
  return new Promise((resolve) => {
    const out = [];
    const step = () => reader.readEntries((batch) => { if (!batch.length) resolve(out); else { out.push(...batch); step(); } }, () => resolve(out));
    step();
  });
}

async function walk(entry, out) {
  if (!entry || SKIP.test(entry.name)) return;
  if (entry.isFile) {
    const file = await new Promise((res) => entry.file(res, () => res(null)));
    if (!file) return;
    const rel = (entry.fullPath || "").replace(/^\//, "") || file.name;
    try { Object.defineProperty(file, "relativePath", { value: rel }); } catch { /* read-only File in some browsers – name is used */ }
    out.push(file);
  } else if (entry.isDirectory) {
    for (const k of await readAll(entry.createReader())) await walk(k, out);
  }
}

/** Every file in a drop – including everything inside dropped folders. Call synchronously from the drop handler (entries must be read in the event). */
export function filesFromDrop(dt) {
  const entries = Array.from(dt?.items || []).map((i) => (typeof i.webkitGetAsEntry === "function" ? i.webkitGetAsEntry() : null));
  if (!entries.some(Boolean)) return Promise.resolve(Array.from(dt?.files || []));
  return (async () => { const out = []; for (const e of entries) await walk(e, out); return out; })();
}

/** Path inside the customer's folder when the file came from one, otherwise just the name. */
export const relPath = (file) => file.relativePath || file.webkitRelativePath || file.name;
